import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function FlexColBreak(props) {
  const { className, breakpoint, ...rest } = props;

  const classes = cx("flex-col-break", {
    "flex-col-break-xs": breakpoint === "xs" || !breakpoint,
    "flex-col-break-sm": breakpoint === "sm",
    "flex-col-break-md": breakpoint === "md",
    "flex-col-break-lg": breakpoint === "lg",
    "flex-col-break-xl": breakpoint === "xl"
  })
  return (
    <div
      className={cx(classes, className)}
      role="presentation"
      data-component="FlexColBreak"
      {...rest} />
  );
}

FlexColBreak.propTypes = {
  className: PropTypes.string,
  breakpoint: PropTypes.oneOf([ "xs", "sm", "md", "lg", "xl" ])
};